import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const Input = ({ placeholder, onChange, id, error, value, ariaLabel, maxLength = '', model, autoFocus, size, radius='all-rounded', type='text', name }) => (
    <div className='floating-label-wrapper'>
        <input className={cx('input', error && 'error', model, size, radius)}
            aria-label={ariaLabel}
            autoFocus={autoFocus}
            id={id}
            maxLength={maxLength}
            onChange={onChange}
            type={type}
            value={value}
            name={name || id}
            required
        />
        <span className='floating-label'>
            {placeholder}
        </span>
    </div>
);

Input.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.string,
    error: PropTypes.bool,
    value: PropTypes.string,
    ariaLabel: PropTypes.string,
    maxLength: PropTypes.string,
    onChange: PropTypes.func,
    autoFocus: PropTypes.bool,
    model: PropTypes.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: PropTypes.string,
    radius: PropTypes.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
}


export default Input



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/InputFloatingLabel.jsx